// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
import ind from '@/views/ind';

// 企业管理
import Goods from '@/views/goods/Goods';
import brand from '@/views/goods/brand';
import goodsmerchant from '@/views/goods/goodsmerchant';
import downOn from '@/views/mch/downOn';



import informationlist from '@/views/information/informationlist';
import pushlist from '@/views/information/pushlist';

// 商家管理
import bus from '@/views/bus/bus';
// 商家审核LIST
import audit from '@/views/bus/audit';


import xiajia from '@/views/bus/xiajia';
import xiajiaxq from '@/views/bus/xiajiaxq';
import wtbus from '@/views/bus/wtbus';

// 商家审核
import auditxq from '@/views/bus/auditxq';
// 商家储值
import storedValue from '@/views/bus/storedValue';
// 商家店员管理
import clerk1 from '@/views/bus/clerk1';
// 修改商家银行卡
import modifyMerchants from '@/views/bus/modifyMerchants';
// 修改商家储值信息
import modifyTheStoredValue from '@/views/bus/modifyTheStoredValue';
// 商家储值
import stored from '@/views/bus/stored';
//重新储值列表
import heavyStorageList from '@/views/pay/heavyStorageList';
//重新储值
import heavyStorage from '@/views/pay/heavyStorage';
//重新续值
import heavyStorage1 from '@/views/pay/heavyStorage1';
import orderCount from '@/views/pay/orderCount';

// 修改商家基础信息
import modifyMerchantsBasis from '@/views/bus/modifyMerchantsBasis';


// 品牌管理
import clerk from '@/views/group/clerk';
// 修改品牌银行卡
import groupBankCard from '@/views/group/groupBankCard';
// 修改品牌信息
import groupModify from '@/views/group/groupModify';
//品牌商家列表
import clerkMerchants from '@/views/group/clerkMerchants';
//品牌商家列表
import sxxq from '@/views/group/sxxq';
import groupdiscount from '@/views/group/groupdiscount.vue';
import groupuser from '@/views/group/groupuser';



/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
// 发票配置
import Config from '@/views/pay/Config';
// 企业充值
import topUp from '@/views/pay/topUp';
// 商家记录
import StoredList from '@/views/pay/StoredList';






// 角色管理
import Role from '@/views/system/Role';;
// 后台成员管理
import Permission from '@/views/system/Permission';


import partner from '@/views/partner/partner';
import paycold from '@/views/paycold/paycold';

import channelzu from '@/views/channel/channelzu';
import refund from '@/views/pay/refund';





import b2cproduct from '@/views/b2c/product.vue';
import b2cproduct1 from '@/views/b2c/product1';
import b2cproduct2 from '@/views/b2c/product2.vue';
import b2cuser from '@/views/b2c/user';
import b2cuser1 from '@/views/b2c/user1.vue';
// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
  routes: [{
    path: '/',
    name: '',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/login',
    name: '登录',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/index',
    name: '首页',
    component: index,
    iconCls: 'el-icon-tickets',
    children: [{
        path: '/ind',
        name: '欢迎',
        component: ind,
        meta: {
          requireAuth: true
        }
      }, 
      
      {
        path: '/b2c/product',
        name: 'b2cproduct',
        component: b2cproduct,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/b2c/product1',
        name: 'b2cproduct1',
        component: b2cproduct1,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/b2c/product2',
        name: 'b2cproduct2',
        component: b2cproduct2,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/b2c/user',
        name: 'b2cuser',
        component: b2cuser,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/b2c/user1',
        name: 'b2cuser1',
        component: b2cuser1,
        meta: {
          requireAuth: true
        }
      }, 
      
      
      
      
      
      
      {
        path: '/goods/Goods',
        name: '企业管理',
        component: Goods,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/goods/brand',
        name: '渠道品牌列表',
        component: brand,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/goods/goodsmerchant',
        name: 'goodsmerchant',
        component: goodsmerchant,
        meta: {
          requireAuth: true
        }
      },


      {
        path: '/information/informationlist',
        name: 'informationlist',
        component: informationlist,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/information/pushlist',
        name: 'pushlist',
        component: pushlist,
        meta: {
          requireAuth: true
        }
      },






      {
        path: '/mch/downOn',
        name: 'downOn',
        component: downOn,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/bus/bus',
        name: '商家管理',
        component: bus,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/bus/audit',
        name: '商家审核',
        component: audit,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/bus/xiajia',
        name: 'xiajia',
        component: xiajia,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/bus/xiajiaxq',
        name: 'xiajiaxq',
        component: xiajiaxq,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/bus/wtbus',
        name: 'wtbus',
        component: wtbus,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/partner/partner',
        name: 'partner',
        component: partner,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/paycold/paycold',
        name: 'paycold',
        component: paycold,
        meta: {
          requireAuth: true
        }
      },

      {
        path: '/bus/auditxq',
        name: '商家审核详情',
        component: auditxq,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/bus/storedValue',
        name: '商家储值',
        component: storedValue,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/bus/clerk1',
        name: 'clerk1',
        component: clerk1,
        meta: {
          requireAuth: false
        }
      }, {
        path: '/bus/modifyMerchants',
        name: '修改银行卡',
        component: modifyMerchants,
        meta: {
          requireAuth: false
        }
      }, {
        path: '/bus/stored',
        name: '商家储值详情',
        component: stored,
        meta: {
          requireAuth: false
        }
      }, {
        path: '/bus/modifyTheStoredValue',
        name: '修改商家储值信息',
        component: modifyTheStoredValue,
        meta: {
          requireAuth: false
        }
      }, {
        path: '/pay/heavyStorageList',
        name: '重新储值商家',
        component: heavyStorageList,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/pay/heavyStorage',
        name: '重储',
        component: heavyStorage,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/pay/heavyStorage1',
        name: '续储',
        component: heavyStorage1,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/bus/modifyMerchantsBasis',
        name: '修改商家信息',
        component: modifyMerchantsBasis,
        meta: {
          requireAuth: false
        }
      },



      {
        path: '/group/clerk',
        name: '品牌管理',
        component: clerk,
        meta: {
          requireAuth: false
        }
      }, {
        path: '/group/groupBankCard',
        name: '修改品牌银行卡',
        component: groupBankCard,
        meta: {
          requireAuth: false
        }
      }, {
        path: '/group/clerkMerchants',
        name: '品牌商家列表',
        component: clerkMerchants,
        meta: {
          requireAuth: false
        }
      }, {
        path: '/group/sxxq',
        name: '商家上线详情',
        component: sxxq,
        meta: {
          requireAuth: false
        }
      }, {
        path: '/group/groupModify',
        name: '修改品牌信息',
        component: groupModify,
        meta: {
          requireAuth: false
        }
      }, {
        path: '/group/groupdiscount',
        name: '修改品牌折扣',
        component: groupdiscount,
        meta: {
          requireAuth: false
        }
      }, {
        path: '/group/groupuser',
        name: 'groupuser',
        component: groupuser,
        meta: {
          requireAuth: false
        }
      },



     {
       path: '/pay/orderCount',
       name: 'orderCount',
       component: orderCount,
       meta: {
         requireAuth: true
       }
     },  {
        path: '/pay/topUp',
        name: '企业充值',
        component: topUp,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/pay/StoredList',
        name: '商家储值记录',
        component: StoredList,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/pay/Order',
        name: '交易订单',
        component: Order,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/pay/Config',
        name: '申请开票列表',
        component: Config,
        meta: {
          requireAuth: true
        }
      },






      {
        path: '/system/Role',
        name: '用户管理',
        component: Role,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/system/Permission',
        name: '角色管理',
        component: Permission,
        meta: {
          requireAuth: true
        }
      },



      {
        path: '/pay/refund',
        name: 'refund',
        component: refund,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/channel/channelzu',
        name: 'channelzu',
        component: channelzu,
        meta: {
          requireAuth: true
        }
      }






    ]
  }]
})


// WEBPACK FOOTER //
// ./src/router/index.js